import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ForwardingLocationApi } from 'api';
import type { ForwardingLocation } from 'api/methods/ForwardingLocationApi';

/**
 * [ForwardingLocation] Query Key 생성
 * --
 */
export const forwardingLocationQueryKeys = createQueryKeys(
  'forwardingLocation',
  {
    getForwardingLocation: (
      idx: number,
      params?: { [key: string]: string | number }
    ) => [idx, params],
    getForwardingLocations: (params?: { [key: string]: string | number }) => [
      params,
    ],
  }
);

/**
 * [ForwardingLocation] 출고지 상세 조회
 * --
 */
export const useGetForwardingLocation = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: forwardingLocationQueryKeys.getForwardingLocation(idx, params)
      .queryKey,
    queryFn: () => ForwardingLocationApi.getForwardingLocation(idx, params),
  });

  return data;
};

/**
 * [ForwardingLocation] 출고지 전체 조회
 * --
 */
export const useGetForwardingLocations = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey:
      forwardingLocationQueryKeys.getForwardingLocations(params).queryKey,
    queryFn: () => ForwardingLocationApi.getForwardingLocations(params),
    ...options,
  });

  return data;
};

/**
 * [ForwardingLocation] 출고지 생성
 * --
 */
export const useCreateForwardingLocation = (body: ForwardingLocation) => {
  const { mutateAsync: createForwardingLocation, ...result } = useMutation({
    mutationFn: (variables: ForwardingLocation) =>
      ForwardingLocationApi.createForwardingLocation(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createForwardingLocation, ...result };
};

/**
 * [ForwardingLocation] 출고지 수정
 * --
 */
export const useUpdateForwardingLocation = (body: ForwardingLocation) => {
  const { mutateAsync: updateForwardingLocation, ...result } = useMutation({
    mutationFn: (variables: ForwardingLocation) =>
      ForwardingLocationApi.createForwardingLocation(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateForwardingLocation, ...result };
};

/**
 * [ForwardingLocation] 출고지 삭제
 * --
 */
export const useDeleteForwardingLocation = (idx: number) => {
  const { mutateAsync: deleteForwardingLocation, ...result } = useMutation({
    mutationFn: (variables: number) =>
      ForwardingLocationApi.deleteForwardingLocation(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteForwardingLocation, ...result };
};
